import { RoomState } from './index';
import { ActionTree } from 'vuex';
// @ts-ignore
import { IState } from "../index";
import { AxiosError, AxiosResponse } from "axios";
import Room from "../interfaces/room";
import CheckoutItem from "../interfaces/checkoutItem";
import { fetchResponse } from '@store/services/fetchCheckoutData';

export default {
    async initRooms({ state, commit, dispatch, rootState, getters }) {
        await fetchResponse(
            rootState.checkout.apiEndpoint,
            'GetAvailableRooms',
            rootState.checkout.checkoutSettings.trip.id,
            rootState.checkout.checkoutSummary.appointmentId,
            rootState.checkout.apiToken,
            rootState.checkout.checkoutSummary.sessionId,
            rootState.checkout.checkoutSummary.fare,
            rootState.checkout.checkoutSettings.locale
        )
            .then((response: AxiosResponse) => {
                commit('initAvailableRooms', response.data);
                commit('checkout/setAdultTravellerCount', rootState.checkout.checkoutSummary.travellerCount.adults, { root: true });

                if (rootState.checkout.checkoutSettings.restoreId !== '' && !state.isRestored) {
                    commit('initRooms');
                    dispatch('restoreRooms');
                    dispatch('funnel/addSelectedToCheckoutFunnel', { type: 'rooms', picked: getters.getSelectedRooms }, { root: true });
                }

                if (!state.hasCustomSelection) {
                    commit('initRooms');
                    commit('setInitialRooms');
                    dispatch('updateCheckoutSummaryRooms');
                }

                dispatch('checkRoomOccupation');
            })
            .catch((e: AxiosError) => {
                const responseStatus = e.response ? e.response.status : 'none';
                const message = `Error in initRooms | Error code: 1642576793677 | HTTP status: ${responseStatus} | ${e.message}`;

                if (rootState.checkout.checkoutSettings.restoreId === '') {
                    dispatch('openErrorOverlay');
                }

                throw Error(message);
            });
    },
    restoreRooms({ commit, dispatch, rootState }) {
        const restoredRooms: CheckoutItem[] = rootState.checkout.preInquiry.bookingRequest.rooms;

        if (restoredRooms.length > 0) {
            commit('resetRoomsAmount', restoredRooms);
        } else {
            commit('setInitialRooms');
            dispatch('updateCheckoutSummaryRooms');
        }
    },
    updateCheckoutSummaryRooms({ commit, dispatch, getters }) {
        const rooms: CheckoutItem[] = [];
        const availableRooms: Room[] = getters.getRooms;

        availableRooms.forEach((room: Room) => {
            if (room.amount > 0) {
                rooms.push({
                    id: room.id,
                    amount: room.amount
                });
            }
        })

        commit('checkout/mapRoomsToCheckoutSummary', rooms, { root: true });
        dispatch('updatePriceSummary');
    },
    updateRoom({ state, commit, dispatch }, { roomId, delta }) {
        const room: Room|undefined = state.rooms.find((r: Room) => r.id === roomId);

        if (room === undefined) {
            return;
        }

        const amount: number = room.amount + delta;

        commit('setRooms', [{
            id: roomId,
            amount: amount
        }]);
        dispatch('updateCheckoutSummaryRooms');
        dispatch('checkRoomOccupation');
    },
    checkRoomOccupation({ commit, getters, dispatch }) {
        const travellersLeft: number = getters.travellersLeft;

        commit('setIsValid', travellersLeft === 0);
        dispatch('initPersonalData');
    }
} as ActionTree<RoomState, IState>
